import React, { Component } from "react";
import "./quillstyles.css";

export class QuillEditor extends Component {
  quillModulesConf = {
    toolbar: false,
  };

  constructor(props) {
    super(props);
    if (typeof window !== "undefined") {
      this.ReactQuill = require("react-quill");
    }
    this.quillRef = React.createRef();
  }

  onChanged = (content, delta, source, editor) => {
    if (this.props.onChange) {
      this.props.onChange(content, delta, source, editor);
    }
  };

  checkCharacterCount = (event) => {
    const unprivilegedEditor = this.quillRef.current.unprivilegedEditor;
    if (this.props.count && unprivilegedEditor && unprivilegedEditor.getLength() > this.props.count && event.key !== 'Backspace')
      event.preventDefault();
  };

  render() {
    const ReactQuill = this.ReactQuill;
    if (typeof window !== "undefined" && ReactQuill) {
      if (this.props.readOnly) {
        return (
          <ReactQuill
            key={this.props.value}
            theme="snow"
            value={this.props.value}
            modules={this.quillModulesConf}
            ref={this.quillRef}
            readOnly={true}
            placeholder=""
          />
        );
      } else {
        return (
          <ReactQuill
              onKeyDown={this.checkCharacterCount}
            onChange={this.onChanged}
            theme="snow"
            defaultValue={!!this.props.value ? this.props.value : ""}
            modules={this.quillModulesConf}
            ref={this.quillRef}
            readOnly={false}
            placeholder={
              this.props.placeholder
                ? this.props.placeholder
                : "Get your ideas down here..."
            }
          />
        );
      }
    } else {
      return <textarea />;
    }
  }
}
